import React from 'react'
import Cards from '@cloudscape-design/components-themed/cards'

// https://cloudscape.design/components/cards
export function RadCards ({ ...rest }) {
  return (
    <Cards {...rest} />
  )
}
